
import React from 'react';
import { Heart, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Shield, QrCode, Map } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const HealthLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Heart,
      title: "Nossos Serviços",
      subtitle: "Soluções para sua saúde digital",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-teal-50",
      textColor: "text-teal-700",
      iconColor: "text-teal-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Saúde",
      subtitle: "Atendimento rápido e seguro",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20Decide%20Digital!",
      bgColor: "bg-green-50",
      textColor: "text-green-700",
      iconColor: "text-green-600"
    },
    {
      icon: Phone,
      title: "Central de Atendimento",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
      iconColor: "text-blue-600"
    },
    {
      icon: Mail,
      title: "Contato Profissional",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      bgColor: "bg-purple-50",
      textColor: "text-purple-700",
      iconColor: "text-purple-600"
    },
    {
      icon: MapPin,
      title: "Localização",
      subtitle: "Encontre nossa clínica",
      url: "https://maps.app.goo.gl/67vmppvo3ERddDZQ9",
      bgColor: "bg-red-50",
      textColor: "text-red-700",
      iconColor: "text-red-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-teal-50 to-blue-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="bg-white rounded-3xl p-6 shadow-lg mb-6">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full flex items-center justify-center">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Decide Digital Health</h1>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Cuidando da saúde digital do seu negócio. Oferecemos soluções seguras, 
              confiáveis e inovadoras para o setor de saúde e bem-estar.
            </p>
            
            {/* Trust Badge */}
            <div className="inline-flex items-center bg-teal-50 px-3 py-1 rounded-full">
              <Shield className="w-4 h-4 text-teal-600 mr-1" />
              <span className="text-teal-700 text-xs font-medium">Certificado de Qualidade</span>
            </div>
          </div>
        </div>

        {/* QR Code Section */}
        <div className="bg-white rounded-2xl p-4 shadow-md mb-6 text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <QrCode className="w-4 h-4 text-teal-600" />
            <p className="text-gray-700 text-sm">Acesse nossos serviços:</p>
          </div>
          <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-3 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110"
            >
              <social.icon className="w-5 h-5 text-teal-600" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 ${link.bgColor} rounded-2xl border border-white/50 shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105`}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mr-4 shadow-sm">
                  <link.icon className={`w-6 h-6 ${link.iconColor}`} />
                </div>
                <div className="flex-1">
                  <div className={`font-semibold ${link.textColor}`}>{link.title}</div>
                  <div className={`text-sm ${link.textColor} opacity-80`}>{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-white rounded-2xl p-4 shadow-md mt-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Map className="w-4 h-4 text-teal-600" />
            <p className="text-gray-700 text-sm font-medium">Nossa localização:</p>
          </div>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={15} />
        </div>

        {/* Health Tip */}
        <div className="bg-white rounded-2xl p-4 mt-6 shadow-sm border border-teal-100">
          <div className="flex items-center">
            <Heart className="w-5 h-5 text-teal-600 mr-2" />
            <span className="text-teal-700 font-medium text-sm">Dica de Saúde Digital</span>
          </div>
          <p className="text-gray-600 text-xs mt-2">
            Mantenha seus dados seguros e atualizados para um atendimento mais eficaz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HealthLinktree;
